export enum PricingMode {
  Session = 0,
  Hourly = 1,
  PerChargingHour = 2,
  EnergyPerKwh = 3,
  Complex = 4,
  TwoPeriod = 5,
}
